import moment from 'moment'
import 'moment-timezone'
import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarMilhar } from '../../../utils/formatarMilhar'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import Table from '../../Table/index.jsx'

import DetalhamentoPedido from './detalhamentoPedido/detalhamentoPedido'
import NovoPedido from './novoPedido/novoPedido'

import '../../../css/painelFaturas/fatPedidos/tabela.css'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
const valorLimite = 50

function TabelaPedidosSimcard() {
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  //   const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  //   const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)

  //   const [cdPedido, setCdPedido] = useState()
  //   const [numeroPedido, setNumeroPedido] = useState()

  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )

  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  const [spinAtivo, setSpinAtivo] = useState(false)
  let itensVar = []

  const despacho = useDispatch()

  let filtros = useSelector((state) => state.filtrosState.filtros)
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let novoFatPedidos = useSelector(
    (state) => state.faturasState.revelarNovoFatPedidos
  )

  //   let excluirFatPedidos = useSelector(
  //     (state) => state.faturasState.revelarExcluirFatPedidos
  //   )

  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(609) // 'fatPedidosTabela'
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(limpadorFiltros(true))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setSpinAtivo(true)
    //despacho redux
    despacho(mudarManejador('faturasPedidos'))
    despacho(desabilitarAcoes(true))
    despacho(desabilitarAcoesCliente(true))
    async function carregarTabela() {
      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          await contarItens()
          const body = {
            paginaAtual: contador,
            carregarLimit: valorLimite,
            buscar: conteudoBusca,
            contar: false,
            contas: decryptJWT('fatContas')
          }
          const { data } = await api_gateway.post(
            '/m1/consultar/fat_pedido',
            body
          )
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const body = {
          paginaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          contar: false,
          contas: decryptJWT('fatContas'),
          filtros: filtros
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post(
            '/m1/filtrar/fat_pedido',
            body
          )

          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const body = {
            paginaAtual: contador,
            carregarLimit: valorLimite,
            buscar: conteudoBusca,
            contar: false,
            contas: decryptJWT('fatContas')
          }
          const { data } = await api_gateway.post(
            '/m1/consultar/fat_pedido',
            body
          )

          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual && filtros.vazio) {
      const body = {
        paginaAtual: contador,
        carregarLimit: valorLimite,
        buscar: conteudoBusca,
        contar: true,
        contas: decryptJWT('fatContas')
      }
      apiData = await api_gateway.post('/m1/consultar/fat_pedido', body)
    } else {
      const body = {
        paginaAtual: contador,
        carregarLimit: valorLimite,
        buscar: conteudoBusca,
        contar: true,
        contas: decryptJWT('fatContas'),
        filtros: filtros
      }
      apiData = await api_gateway.post('/m1/filtrar/fat_pedido', body)
    }
    itensVar = []
    if (apiData.data.dados) {
      totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
      totalItens = apiData.data.dados[0].CONTADOR
      for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
        arrayItens.push(i)
      }
      itensVar = arrayItens
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      setRenderizar(!renderizar)
      restaurarConfigsIniciaisPagina()
      if (confirmacao === true) {
        //ALGUMA FUNÇÃO
      }
    }
  }

  const colunas = [
    {
      dataField: 'NPEDIDO',
      headerClasses: 'nao-selecionavel',
      text: 'N° do pedido',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'DT_PEDIDO',
      headerClasses: 'nao-selecionavel',
      text: 'Data pedido',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '0000-00-00 00:00:00' &&
            cell != null &&
            cell != 'Invalid date'
              ? moment(cell).format('DD/MM/YYYY')
              : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'DS_FORNECEDOR',
      headerClasses: 'nao-selecionavel',
      text: 'Fornecedor',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'DS_OPERADORA',
      headerClasses: 'nao-selecionavel',
      text: 'Operadora',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'VALOR_PLANO',
      headerClasses: 'nao-selecionavel',
      text: 'Valor do plano',
      sort: true,

      formatter: (cell) => {
        const valor = parseFloat(cell)
        return (
          <div className="fonte-cor-1 label-tabela-1 container-valor-pedidosSimcard">
            {' '}
            {!valor || isNaN(valor) ? (
              <>
                <p className="valor-rs-pedidosSimcard">R$</p>{' '}
                <p className="fonte-cor-1 valor-pedidosSimcard"> 0.00 </p>
              </>
            ) : (
              <>
                <p className="valor-rs-pedidosSimcard">R$</p>{' '}
                <p className="fonte-cor-1 valor-pedidosSimcard">
                  {' '}
                  {formatarMilhar(valor)}
                </p>
              </>
            )}{' '}
          </div>
        )
      }
    },
    {
      dataField: 'DS_CONTA',
      headerClasses: 'nao-selecionavel',
      text: 'Conta',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'DS_NF',
      headerClasses: 'nao-selecionavel',
      text: ' N° da NF',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'QTD_SIMCARD',
      headerClasses: 'nao-selecionavel',
      text: 'Quantidade de SIM cards',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'DT_EMISSAO_NF',
      headerClasses: 'nao-selecionavel',
      text: 'Data emissão NF',
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '0000-00-00 00:00:00' &&
            cell != null &&
            cell != 'Invalid date'
              ? moment(cell).format('DD/MM/YYYY')
              : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'DT_ATIVACAO',
      headerClasses: 'nao-selecionavel',
      text: 'Data de ativação',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '0000-00-00 00:00:00' &&
            cell != null &&
            cell != 'Invalid date'
              ? moment(cell).format('DD/MM/YYYY')
              : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'PRAZO_PERMANENCIA',
      headerClasses: 'nao-selecionavel',
      text: 'Prazo de permanência',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '0000-00-00 00:00:00' &&
            cell != null &&
            cell != 'Invalid date'
              ? moment(cell).format('DD/MM/YYYY')
              : '-'}
          </p>
        )
      }
    }
  ]

  //   useEffect(() => {
  //     if (excluirFatPedidos) {
  //       setRevelarMensagemAtencao(true)
  //     }
  //   }, [excluirFatPedidos])

  //   function handleMensagemAtencao(confirmacao) {
  //     if (revelarMensagemAtencao === false) {
  //       setRevelarMensagemAtencao(true)
  //     } else {
  //       setRevelarMensagemAtencao(false)
  //       despacho(revelarExcluirFatPedidos(false))

  //       if (confirmacao === true) {
  //         handleDeletar()
  //       }
  //     }
  //   }

  //   async function handleDeletar() {
  //     setSpinAtivo(true)
  //     await api_gateway
  //       .get('/m1/deletar/fat_pedido?cd_fat_pedido=' + cdPedido)
  //       .then(function () {
  //         setRenderizar(!renderizar)
  //         despacho(revelarExcluirFatPedidos(false))
  //         handleMensagemSucesso(false)
  //         setRevelarMensagemAtencao(false)
  //         setSpinAtivo(false)
  //       })
  //       .catch(function () {
  //         despacho(revelarExcluirFatPedidos(false))
  //         handleMensagemErro(false)
  //         setRevelarMensagemAtencao(false)
  //         setSpinAtivo(false)
  //       })
  //   }

  //   function handleMensagemErro(confirmacao) {
  //     if (revelarMensagemErro === false) {
  //       setRevelarMensagemErro(true)
  //     } else {
  //       setRevelarMensagemErro(false)
  //       if (confirmacao === true) {
  //         //ALGUMA FUNÇÃO
  //       }
  //     }
  //   }

  const renderDetalhamentoLinha = (row) => {
    return (
      <div className="expand-row-tabela-fatPedidos">
        <DetalhamentoPedido cd_fat_pedido={row.CD_FAT_PEDIDO} />
      </div>
    )
  }

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  return (
    <div className="container-tela">
      <Table
        keyField="NUMERO_PEDIDO"
        clickToSelect
        revelarContador
        spinAtivo={spinAtivo}
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        permissaoDetalhamentoLinha
        detalhamentLinha={renderDetalhamentoLinha}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
      />
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}

      {novoFatPedidos === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <NovoPedido
              tituloJanela="Cadastrar"
              setRenderizar={setRenderizar}
              renderizar={renderizar}
            />
          </div>
        </div>
      )}
      {/* {revelarMensagemAtencao === true && (
        <MensagemConfirmarExclusao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo={'Deletar ' + numeroPedido}
        />
      )} */}

      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="Pedido excluído."
              mensagemBotao="OK"
            />
          </div>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}
export default connect(mapStateToProps)(React.memo(TabelaPedidosSimcard))
